// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/header/menu.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
    height: 70px;
  }
  .header_qubx_logo__0UTxf {
    width: 100px;
  }
  .header_notification_label__eSeJf,
  .header_profile_img__1DQI7 {
    width: 45px;
  }
  header_a {
    color: #f3f2f2;
  }
  .header_header_info__ZaUfT {
    display: flex;
    right: 60px;
    top: 19px;
    flex-direction: row;
    justify-content: flex-end;
  }
  /* button[type="button"] {
    background-color: #535780;
    margin-top: 30px;
  } */
  .header_navbar-toggler-icon__F\\+gr- {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  }
  .header_dropdown-item_a__HEBHX:hover{
    background-color: blueviolet;
  }
  @media only screen and (max-width: 991px) {
    .header_nav_section__mvx14 {
      height: auto !important;
    }
    .header_nav_box__NInAN {
      justify-content: flex-start !important;
    }
    .header_header_info__ZaUfT {
      right: 20px;
      top: 10px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/header/header.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;;;KAGG;EACH;IACE,oEAAkE;EACpE;EACA;IACE,4BAA4B;EAC9B;EACA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,sCAAsC;IACxC;IACA;MACE,WAAW;MACX,SAAS;IACX;EACF","sourcesContent":["nav {\n    height: 70px;\n  }\n  .qubx_logo {\n    width: 100px;\n  }\n  .notification_label,\n  .profile_img {\n    width: 45px;\n  }\n  header_a {\n    color: #f3f2f2;\n  }\n  .header_info {\n    display: flex;\n    right: 60px;\n    top: 19px;\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n  /* button[type=\"button\"] {\n    background-color: #535780;\n    margin-top: 30px;\n  } */\n  .navbar-toggler-icon {\n    background-image: url(\"/public/images/header/menu.svg\") !important;\n  }\n  .dropdown-item_a:hover{\n    background-color: blueviolet;\n  }\n  @media only screen and (max-width: 991px) {\n    .nav_section {\n      height: auto !important;\n    }\n    .nav_box {\n      justify-content: flex-start !important;\n    }\n    .header_info {\n      right: 20px;\n      top: 10px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qubx_logo": `header_qubx_logo__0UTxf`,
	"notification_label": `header_notification_label__eSeJf`,
	"profile_img": `header_profile_img__1DQI7`,
	"header_info": `header_header_info__ZaUfT`,
	"navbar-toggler-icon": `header_navbar-toggler-icon__F+gr-`,
	"dropdown-item_a": `header_dropdown-item_a__HEBHX`,
	"nav_section": `header_nav_section__mvx14`,
	"nav_box": `header_nav_box__NInAN`
};
export default ___CSS_LOADER_EXPORT___;
